import { createStore, applyMiddleware, combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import thunkMiddleware from 'redux-thunk'
import * as reducers from './reducers'
const __DEV__ = process.env.NODE_ENV !== 'production'
const reducer = combineReducers({
    ...reducers,
    routing: routerReducer
})
const simplelogger = (store: any) => (next: any) => (action: any) => {
    next(action)
    // __DEV__ && console.log('finish----', action, store.getState())
}
let middles = applyMiddleware(thunkMiddleware)
/* */
if (__DEV__) {
    middles = applyMiddleware(thunkMiddleware, simplelogger)
}
export default function configureStore(initialState?: any) {
    const store = createStore(
        reducer,
        initialState,
        middles
    )
    return store
}
